export default __webpack_public_path__ + "static/media/InSight.5e93f279.png";